import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { ReportsMonthlyRenewal } from '../../containers/reports/ReportsMonthlyRenewal';

export const AdminReportsMonthlyPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<ReportsMonthlyRenewal />
		</AdminDashboardPageLayout>
	);
};
